import { memo, useEffect, useMemo } from "react";

import {
  type CountryCode,
  type MoneyV2,
} from "@shopify/hydrogen-react/storefront-api-types";

import { type ThemeMode } from "@root/tablescape/state";

import { KlarnaView } from "./Klarna.view";

type Props = {
  country: CountryCode;
  price: MoneyV2;
  theme: ThemeMode;
};

const KlarnaBase = ({ country, price, theme }: Props) => {
  useEffect(() => {
    const refreshKlarna = () => {
      if (!price?.amount) {
        return;
      }

      if (window.Klarna) {
        window.Klarna.OnsiteMessaging.refresh();
      }
    };
    window.addEventListener("shopify:section:load", refreshKlarna);

    return () => {
      window.removeEventListener("shopify:section:load", refreshKlarna);
    };
  }, [price?.amount]);

  const locale = useMemo(() => {
    if (country === "CA") {
      return "en-CA";
    }
    if (country === "GB") {
      return "en-GB";
    }
    return "en-US";
  }, [country]);

  const formattedPrice = useMemo(() => {
    return Number(price.amount) * 100;
  }, [price]);

  if (formattedPrice <= 0) {
    return null;
  }

  return <KlarnaView locale={locale} price={formattedPrice} theme={theme} />;
};

export const Klarna = memo(KlarnaBase);
